import { EndpointItem, InitializerExecutor } from '@wajeez-web/core/types';
import GeneralAnalysis from './pages/GeneralAnalysisPage';
import ContentAnalysisPage from './pages/ContentAnalysisPage';
import PremiumUsersAnalysisPage from './pages/PremiumUsersAnalysisPage';
import UserActivityAnalysisPage from './pages/UserActivityAnalysisPage';
import PaymentAnalysisPage from './pages/PaymentAnalysisPage';
import { NavigationActions } from '@wajeez-web/stores/common';
import DailyPaymentAnalysis from './pages/DailyPaymentAnalysis';
import { TbBrandGoogleAnalytics } from 'react-icons/tb';
import PredectedAnalysisPage from './pages/PredectedAnalysisPage';
import DCPAnalysis from './pages/DCPAnalysis';

export const initializeAnalysisNavigation: InitializerExecutor = async (
  dispatch
) => {
  dispatch(
    NavigationActions.updateRoutes([
      {
        name: 'Analysis',
        href: '/analysis',
        per: ['120.8', '120.0','121.7', '121.2','120.7', '120.6', '120.4', '120.15','123.0','120.8', '120.10', '120.11', '120.12','121.14', '121.8', '121.6', '121.11','121.10', '121.13','121.15','121.16'],
        icon: TbBrandGoogleAnalytics,
        children: [
          {
            name: 'General Analysis',
            href: '/general-analysis',
            per: ['121.7', '121.2'],
          },
          {
            name: 'Content Analysis',
            href: '/content-analysis',
            per: ['120.7', '120.6', '120.4', '120.15'],
          },
          {
            name: 'Premium Users Analysis',
            href: '/premium-users-analysis',
            per: ['123.0'],
          },
          {
            name: 'User Activity Analysis',
            href: '/user-activity-analysis',
            per: ['120.8', '120.10', '120.11', '120.12'],
          },
          {
            name: 'Payment Analysis',
            href: '/payment-analysis',
            per: ['121.14', '121.8', '121.6', '121.11'],
          },
          {
            name: 'Daily Payment Analysis',
            href: '/daily-payment-analysis',
            per: ['121.10', '121.13'],
          },
          {
            name: 'DCP Analysis',
            href: '/dcp-analysis',
            per: ['121.15'],
          },
          {
            name: 'Predicted Analysis',
            href: '/predicted-analysis',
            per: ['121.16'],
          },
        ],
      },
    ])
  );
};

export const initializeAnalysisEndpoints: InitializerExecutor = async (
  dispatch
) => {
  dispatch(
    NavigationActions.updateEndpoints([
      {
        type: 'container',
        endpoint: 'general-analysis',
        per: ['120.8', '120.0'],
        crump: 'general-analysis',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: GeneralAnalysis,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'content-analysis',
        per: ['120.8', '120.0'],
        crump: 'content-analysis',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: ContentAnalysisPage,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'premium-users-analysis',

        per: ['120.8', '120.0'],
        crump: 'premium-users-analysis',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: PremiumUsersAnalysisPage,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'user-activity-analysis',
        per: ['120.8', '120.0'],
        crump: 'user-activity-analysis',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: UserActivityAnalysisPage,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'payment-analysis',
        per: ['120.8', '120.0'],
        crump: 'payment-analysis',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: PaymentAnalysisPage,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'daily-payment-analysis',
        per: ['120.8', '120.0'],
        crump: 'daily-payment-analysis',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: DailyPaymentAnalysis,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'dcp-analysis',
        per: ['121.15'],
        crump: 'dcp-analysis',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: DCPAnalysis,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'predicted-analysis',
        per: ['120.8', '120.0'],
        crump: 'predicted-analysis',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: PredectedAnalysisPage,
            per: [],
          },
        ],
      },
    ])
  );
};
